import { container, title } from "assets/jss/material-kit-react.js";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const expositionPageStyle = {
  container,
  top: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)"
    }
  },
  white:{
    color:"white !important"
  },
  fileUploader:{
display:"none",
backgroundColor:"red"
  },
  profileImageEditButton:{
    right: "-54px",
    borderRadius: "100%",
    textAlign: "center",
    position: "relative",
    display: "inline-block",
    top: "-37px",
    color: "white",
    backgroundColor: "#4caf50",
    width: "35px",
    height: "35px",
    padding: "5px",
    verticalAlign: "middle"

  },

  name: {
    marginTop: "-80px"
  },

  ...imagesStyle,
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  box: {
    paddingBottom: "10px",
    paddingBottom: "50px",
    textAlign: "left",
    direction: "ltr"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  price: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "50px",
    minHeight: "32px",
    textDecoration: "none",
    color:"#37474f"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  navWrapper: {
    margin: "50px auto 0px auto",
    textAlign: "center"
  },
  fastAccess:{
    direction:"ltr",
    textAlign:"left",
    marginTop:"10px",
  },
  fastAccessButton:{
backgroundColor:"#f50057"
  },
  direction:{
    direction:"ltr"
  },
  extra: {
    display: "block",
    width: "100%",
    height: "100%",
    textAlign: "left"
  },
  media: {
    height: 140,
  },
  description: {
    margin: "1.071rem auto 0",
    textAlign: "justify !important"
  },
  name: {
    marginTop: "-80px"
  },
  justify: {
    textAlign: "left",
    direction: "ltr",
    textAlign: "justify"
  },
  image: {
    width: "50%",
  },
  header:{
    backgroundColor:"#414141",
    color:"#FFF",
    "& div": {
    padding: "5px 0 5px 0",
    }
  },
  tableTitle:{
    margin: "5px 0 20px 0",
    fontWeight: "bold"
  },
  center: {
    textAlign: "center"
  },
  rightToLeft: {
    textAlign: "left",
    direction: "ltr"
  },
  successButton: {
    color: "green",
  },
  productLogo:{
    width:"100%"
  },
  classLogo:{
    width:"100%"
  },
  column: {
    width:"100%",
  },
  columnItem:{
    paddingTop:"12px"
  },
  totalPrice:{
    padding:"12px"
  },
  pay:{
    padding:"12px"
  },
  description:{
    padding:"30px"
  },
buttonMargin:{
marginRight:"10px",
marginLeft:"10px"
}
};

export default expositionPageStyle;
